import { render, staticRenderFns } from "./ManagePriceListImport.vue?vue&type=template&id=ef682f5c&scoped=true"
import script from "./ManagePriceListImport.vue?vue&type=script&lang=js"
export * from "./ManagePriceListImport.vue?vue&type=script&lang=js"
import style0 from "./ManagePriceListImport.vue?vue&type=style&index=0&id=ef682f5c&prod&scoped=true&lang=css"
import style1 from "./ManagePriceListImport.vue?vue&type=style&index=1&id=ef682f5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef682f5c",
  null
  
)

export default component.exports